/**
 * FAIR Toast — RedisiginProductPage `117:12250`
 * Center, 40px from bottom, 3000ms (Fair v1 D6 — keep until designer says otherwise).
 * Visual: dark pill · Inter 12 · check / error 12 · underlined muted-on-dark link.
 */

/** Auto-dismiss duration (ms) — plain toast (Figma 146:13484). */
export const FAIR_TOAST_LIFE_MS = 3000

/** Interactive toast (with link / undo) — Figma with-link 5s. */
export const FAIR_TOAST_INTERACTIVE_LIFE_MS = 5000

/** Distance from the bottom edge of the viewport / content (px). */
export const FAIR_TOAST_BOTTOM_OFFSET_PX = 40

/** T-009 — the like toast dismisses itself after 4 s, without a timer bar. */
export const FAIR_TOAST_LIKE_LIFE_MS = 4000
